var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Box, Button } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import { useWebgate } from "@xvia/webgate-connect";
import { useAccessTokenRef } from "../../hooks/useAccessTokenRef";
import { deleteNpsForm, getAllNpsForms, patchNpsForm } from "../../apis/nps";
import { getApiErrorMessage } from "../../utils/forms.functions";
import { getDefaultSlugFromSlugs } from "../../utils/helpers";
import NpsDownloadDialog from "./NpsDownloadDialog";
import DeleteConfirmationDialog from "../shared/DeleteConfirmationDialog";
import PublishConfirmationDialog from "../shared/PublishConfirmationDialog";
import DuplicateConfirmationDialog from "../shared/DuplicateConfirmationDialog";
import FormDataTable from "../shared/FormDataTable";
import FormSlugsManagerDialog from "../shared/FormSlugsManagerDialog";
import { DEFAULT_LIMIT, DEFAULT_PAGE, } from "../../constants/pagination.constants";
import { PREVIEW_QUERY_PARAM, RENDER_NPS_URL_PREFIX, SEARCH_DEBOUNCE_MS, SEARCH_FIELD_OPTIONS, } from "../../constants/forms.constants";
var NpsList = function () {
    var _a;
    var navigate = useNavigate();
    var _b = useWebgate(), accessToken = _b.accessToken, userInfo = _b.userInfo;
    var _c = useAccessTokenRef(), accessTokenRef = _c.accessTokenRef, hasAccessToken = _c.hasAccessToken;
    var _d = useState([]), rows = _d[0], setRows = _d[1];
    var _e = useState(null), meta = _e[0], setMeta = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(null), error = _g[0], setError = _g[1];
    var _h = useState({
        page: DEFAULT_PAGE,
        limit: DEFAULT_LIMIT,
    }), pagination = _h[0], setPagination = _h[1];
    var _j = useState(""), searchQuery = _j[0], setSearchQuery = _j[1];
    var _k = useState(SEARCH_FIELD_OPTIONS[0].value), searchField = _k[0], setSearchField = _k[1];
    var _l = useState(""), debouncedSearchQuery = _l[0], setDebouncedSearchQuery = _l[1];
    var _m = useState(null), pendingDelete = _m[0], setPendingDelete = _m[1];
    var _o = useState(false), deleting = _o[0], setDeleting = _o[1];
    var _p = useState(null), pendingTogglePublish = _p[0], setPendingTogglePublish = _p[1];
    var _q = useState(false), toggling = _q[0], setToggling = _q[1];
    var _r = useState(null), downloadTarget = _r[0], setDownloadTarget = _r[1];
    var _s = useState(null), slugManagerFormId = _s[0], setSlugManagerFormId = _s[1];
    var debounceTimerRef = useRef(null);
    var patchRowSlugs = useCallback(function (rowId, patch) {
        setRows(function (prev) {
            return prev.map(function (row) { return (row.id === rowId ? __assign(__assign({}, row), patch) : row); });
        });
    }, []);
    var slugManagerRow = slugManagerFormId !== null
        ? rows.find(function (row) { return row.id === slugManagerFormId; })
        : undefined;
    useEffect(function () {
        if (slugManagerFormId !== null &&
            !rows.some(function (row) { return row.id === slugManagerFormId; })) {
            setSlugManagerFormId(null);
        }
    }, [slugManagerFormId, rows]);
    var _t = useState(null), pendingDuplicate = _t[0], setPendingDuplicate = _t[1];
    var handleSearchQueryChange = useCallback(function (value) {
        setSearchQuery(value);
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
        }
        debounceTimerRef.current = setTimeout(function () {
            setDebouncedSearchQuery(value);
        }, SEARCH_DEBOUNCE_MS);
    }, []);
    useEffect(function () {
        return function () {
            if (debounceTimerRef.current) {
                clearTimeout(debounceTimerRef.current);
            }
        };
    }, []);
    useEffect(function () {
        var token = accessTokenRef.current;
        if (!token) {
            setLoading(false);
            setRows([]);
            setMeta(null);
            return;
        }
        var cancelled = false;
        setLoading(true);
        setError(null);
        getAllNpsForms(pagination.page, pagination.limit, token, debouncedSearchQuery, searchField)
            .then(function (res) {
            if (cancelled)
                return;
            setRows(res.data);
            setMeta(res.meta);
        })
            .catch(function (err) {
            if (cancelled)
                return;
            setError(getApiErrorMessage(err, "Não foi possível carregar os formulários NPS."));
            setRows([]);
            setMeta(null);
        })
            .finally(function () {
            if (!cancelled)
                setLoading(false);
        });
        return function () {
            cancelled = true;
        };
    }, [
        hasAccessToken,
        accessTokenRef,
        pagination.page,
        pagination.limit,
        debouncedSearchQuery,
        searchField,
    ]);
    var handlePageChange = useCallback(function (page) {
        setPagination(function (prev) { return (__assign(__assign({}, prev), { page: page })); });
    }, []);
    var handleLimitChange = useCallback(function (limit) {
        setPagination(function (prev) { return (__assign(__assign({}, prev), { limit: limit })); });
    }, []);
    var handleEdit = useCallback(function (row) {
        navigate("/nps/edit/".concat(encodeURIComponent(getDefaultSlugFromSlugs(row.slugs))));
    }, [navigate]);
    var handleDownload = useCallback(function (row) {
        if (!accessToken) {
            setError("Autentique-se para baixar as respostas.");
            return;
        }
        setError(null);
        setDownloadTarget(row);
    }, [accessToken]);
    var handleCloseDownloadDialog = useCallback(function () {
        setDownloadTarget(null);
    }, []);
    var handleTogglePublish = useCallback(function (row) {
        setPendingTogglePublish(row);
    }, []);
    var handleClosePublishDialog = useCallback(function () {
        if (!toggling) {
            setPendingTogglePublish(null);
        }
    }, [toggling]);
    var handleConfirmTogglePublish = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var row, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingTogglePublish || !accessToken)
                        return [2 /*return*/];
                    row = pendingTogglePublish;
                    setToggling(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, patchNpsForm(getDefaultSlugFromSlugs(row.slugs), {
                            published: !row.published,
                            userUpdated: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.preferred_username) || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.name) || "Sem dados",
                        }, accessToken)];
                case 2:
                    _a.sent();
                    setRows(function (prev) {
                        return prev.map(function (prevRow) {
                            return prevRow.id === row.id
                                ? __assign(__assign({}, prevRow), { published: !row.published }) : prevRow;
                        });
                    });
                    setPendingTogglePublish(null);
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    setError(getApiErrorMessage(err_1, "Não foi possível alterar a publicação do formulário NPS."));
                    return [3 /*break*/, 5];
                case 4:
                    setToggling(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); }, [pendingTogglePublish, accessToken, userInfo]);
    var handleDelete = useCallback(function (row) {
        setPendingDelete(row);
    }, []);
    var handleVisualize = useCallback(function (row) {
        window.open("".concat(process.env.PORTAL_URL).concat(RENDER_NPS_URL_PREFIX).concat(encodeURIComponent(getDefaultSlugFromSlugs(row.slugs)), "?").concat(PREVIEW_QUERY_PARAM, "=true"), "_blank");
    }, []);
    var handleManageSlugs = useCallback(function (row) {
        if (!accessToken) {
            setError("Autentique-se para gerenciar slugs.");
            return;
        }
        setSlugManagerFormId(row.id);
    }, [accessToken]);
    var handleCloseDeleteDialog = useCallback(function () {
        if (!deleting) {
            setPendingDelete(null);
        }
    }, [deleting]);
    var handleConfirmDelete = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var wasLastOnPage, deletedId_1, err_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!pendingDelete || !accessToken)
                        return [2 /*return*/];
                    wasLastOnPage = rows.length === 1 && pagination.page > 1;
                    setDeleting(true);
                    setError(null);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 5, 6, 7]);
                    if (!userInfo) return [3 /*break*/, 3];
                    return [4 /*yield*/, patchNpsForm(getDefaultSlugFromSlugs(pendingDelete.slugs), {
                            userDeleted: userInfo.preferred_username || userInfo.name || "Sem dados",
                        }, accessToken)];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3: return [4 /*yield*/, deleteNpsForm(getDefaultSlugFromSlugs(pendingDelete.slugs), accessToken)];
                case 4:
                    _a.sent();
                    deletedId_1 = pendingDelete.id;
                    setPendingDelete(null);
                    if (wasLastOnPage) {
                        setPagination(function (prev) { return (__assign(__assign({}, prev), { page: Math.max(1, prev.page - 1) })); });
                    }
                    else {
                        setRows(function (prev) { return prev.filter(function (prevRow) { return prevRow.id !== deletedId_1; }); });
                        setMeta(function (prev) {
                            return prev
                                ? __assign(__assign({}, prev), { total: Math.max(0, prev.total - 1), totalPages: Math.max(0, Math.ceil(Math.max(0, prev.total - 1) / prev.limit)) }) : null;
                        });
                    }
                    return [3 /*break*/, 7];
                case 5:
                    err_2 = _a.sent();
                    setError(getApiErrorMessage(err_2, "Não foi possível excluir o formulário NPS."));
                    return [3 /*break*/, 7];
                case 6:
                    setDeleting(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); }, [pendingDelete, accessToken, userInfo, rows.length, pagination.page]);
    var handleDuplicate = useCallback(function (row) {
        setPendingDuplicate(row);
    }, []);
    var handleCloseDuplicateDialog = useCallback(function () {
        setPendingDuplicate(null);
    }, []);
    var handleConfirmDuplicate = useCallback(function () {
        if (!pendingDuplicate)
            return;
        setPendingDuplicate(null);
        navigate("/nps?copyForm=".concat(encodeURIComponent(getDefaultSlugFromSlugs(pendingDuplicate.slugs))));
    }, [navigate, pendingDuplicate]);
    return (_jsxs(Box, __assign({ sx: { maxWidth: "1520px", margin: "0 auto", px: 2, py: 3 } }, { children: [!accessToken && (_jsx(Alert, __assign({ severity: "info", sx: { mb: 2 } }, { children: "Autentique-se no portal para carregar a listagem de formul\u00E1rios NPS." }))), error && (_jsx(Alert, __assign({ severity: "error", sx: { mb: 2 }, onClose: function () { return setError(null); } }, { children: error }))), _jsx(FormDataTable, { title: "Formul\u00E1rios NPS", actions: _jsx(Button, __assign({ variant: "contained", size: "small", startIcon: _jsx(AddOutlinedIcon, {}), onClick: function () { return navigate("/nps"); } }, { children: "Novo NPS" })), searchQuery: searchQuery, searchField: searchField, searchPlaceholder: "Buscar formul\u00E1rios NPS", searchFieldOptions: SEARCH_FIELD_OPTIONS, onSearchQueryChange: handleSearchQueryChange, onSearchFieldChange: setSearchField, onBack: function () { return navigate("/"); }, rows: rows, meta: meta, loading: loading, onPageChange: handlePageChange, onRowsPerPageChange: handleLimitChange, onEdit: handleEdit, onDownload: handleDownload, onTogglePublish: handleTogglePublish, onDelete: handleDelete, onVisualize: handleVisualize, onManageSlugs: handleManageSlugs, onDuplicate: handleDuplicate }), _jsx(DeleteConfirmationDialog, { open: pendingDelete !== null, deleting: deleting, entityLabel: "o formul\u00E1rio NPS", itemTitle: pendingDelete === null || pendingDelete === void 0 ? void 0 : pendingDelete.title, ariaPrefix: "nps", onClose: handleCloseDeleteDialog, onConfirm: handleConfirmDelete }), _jsx(PublishConfirmationDialog, { open: pendingTogglePublish !== null, publishing: toggling, isPublishing: !(pendingTogglePublish === null || pendingTogglePublish === void 0 ? void 0 : pendingTogglePublish.published), entityLabel: "o formul\u00E1rio NPS", itemTitle: pendingTogglePublish === null || pendingTogglePublish === void 0 ? void 0 : pendingTogglePublish.title, ariaPrefix: "nps", onClose: handleClosePublishDialog, onConfirm: handleConfirmTogglePublish }), _jsx(FormSlugsManagerDialog, { open: slugManagerFormId !== null &&
                    slugManagerRow !== undefined &&
                    !!accessToken, onClose: function () { return setSlugManagerFormId(null); }, row: slugManagerRow !== null && slugManagerRow !== void 0 ? slugManagerRow : null, accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : "", kind: "nps", onPatchRow: patchRowSlugs }), _jsx(DuplicateConfirmationDialog, { open: pendingDuplicate !== null, entityLabel: "o formul\u00E1rio NPS", itemTitle: pendingDuplicate === null || pendingDuplicate === void 0 ? void 0 : pendingDuplicate.title, ariaPrefix: "nps", onClose: handleCloseDuplicateDialog, onConfirm: handleConfirmDuplicate }), _jsx(NpsDownloadDialog, { open: downloadTarget !== null, formId: (_a = downloadTarget === null || downloadTarget === void 0 ? void 0 : downloadTarget.id) !== null && _a !== void 0 ? _a : "", formSlug: getDefaultSlugFromSlugs(downloadTarget === null || downloadTarget === void 0 ? void 0 : downloadTarget.slugs), formTitle: downloadTarget === null || downloadTarget === void 0 ? void 0 : downloadTarget.title, accessToken: accessToken !== null && accessToken !== void 0 ? accessToken : "", onClose: handleCloseDownloadDialog, onDownloadError: setError })] })));
};
export default NpsList;
